module.exports = require("core-js/modules/esnext.map.every.js");